import { render, staticRenderFns } from "./TagCircle.vue?vue&type=template&id=27e03bc4&scoped=true&"
import script from "./TagCircle.vue?vue&type=script&lang=ts&"
export * from "./TagCircle.vue?vue&type=script&lang=ts&"
import style0 from "./TagCircle.vue?vue&type=style&index=0&id=27e03bc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e03bc4",
  null
  
)

export default component.exports